// Use window.location.origin in production to ensure same-origin requests
// This helps avoid cross-domain cookie issues
export const API_URL = process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : (process.env.REACT_APP_API_URL || 'http://localhost:3005');